// extracted by mini-css-extract-plugin
export default {"simple":"SkeletonList_simple__bDLqu","circle":"SkeletonList_circle__SvioA","list":"SkeletonList_list__7GDXN","error":"SkeletonList_error__6ewas"};